export function militaryTimeMask(
  value: any // eslint-disable-line @typescript-eslint/no-explicit-any
) {
  const default24Mask = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];
  const limit24Mask = [/[0-2]/, /[0-3]/, ':', /[0-5]/, /[0-9]/];

  const char1 = value[0];
  if (char1 > 1) {
    return limit24Mask;
  }

  return default24Mask;
}
